import React from 'react';
import { styled } from '@linaria/react';

interface Props {
  value: string | number;
  renderer?: (value: string | number) => React.ReactNode;
}

function ValuePreview({ value, renderer }: Props) {
  return (
    <Wrapper>
      {typeof renderer === 'function' ? renderer(value) : value}
    </Wrapper>
  );
}

const Wrapper = styled.span`
  font-size: 0.875rem;
  color: var(--color-gray-800);
`;

export default ValuePreview;
